export default {
  cargasArrayAdmin: [
    {
      nombre: 'Mensajes',
      accion: 'auth/getMensajes',
      loading: false
    },
    {
      nombre: 'Estado cuentas',
      accion: 'app/getStatusCuentas',
      loading: false
    },

    {
      nombre: 'Dashboard Config',
      accion: 'app/getConfiguracionDashboard',
      loading: false
    },
    {
      nombre: 'Negocios',
      accion: 'negocios/getNegocios',
      loading: false
    },
    {
      nombre: 'Directorios',
      accion: 'directorios/getDirectorios',
      loading: false
    },
    {
      nombre: 'Restaurantes Todos',
      accion: 'negocios/getAllRestaurantes',
      loading: false
    },
    {
      nombre: 'Características',
      accion: 'caracteristicas/getCaracteristicas',
      loading: false
    },
    // {
    //   nombre: 'Usuarios',
    //   accion: 'users/getUsuarios',
    //   loading: false
    // },
    {
      nombre: 'Impuestos',
      accion: 'impuestos/getImpuestos',
      loading: false
    },
    {
      nombre: 'Cocinas',
      accion: 'cocinas/getCocinas',
      loading: false
    },
    {
      nombre: 'Pedidos pendiente pago',
      accion: 'pedidos/getPedidosGlobalPendientePago',
      loading: false
    },
    {
      nombre: 'Pedidos',
      accion: 'pedidos/getPedidosGlobal',
      loading: false
    },
    {
      nombre: 'Pedidos Eliminar',
      accion: 'pedidos/getPedidosEliminar',
      loading: false
    },
    {
      nombre: 'Alertas',
      accion: 'alertas/getAlertas',
      loading: false
    },
    {
      nombre: 'Partners',
      accion: 'partners/getPartners',
      loading: false
    },


  ],
  cargasArrayNegocio: [
    {
      nombre: 'Pedidos',
      accion: 'negocios/getPedidosNegocio',
      loading: false
    },

    // {
    //   nombre: 'Clientes',
    //   accion: 'negocios/getClientesNegocioCall',
    //   loading: false,
    //   lazy: true
    // },
    {
      nombre: 'Restaurantes',
      accion: 'restaurantes/getRestaurantes',
      loading: false
    },
    {
      nombre: 'Categorias',
      accion: 'categorias/getCategorias',
      loading: false
    },
    {
      nombre: 'Productos',
      accion: 'productos/getProductos',
      loading: false
    },
    {
      nombre: 'Menus',
      accion: 'productos/getMenus',
      loading: false
    },
    {
      nombre: 'Productos',
      accion: 'productos/getTarifas',
      loading: false
    },
    {
      nombre: 'Ordenadores Printnode',
      accion: 'negocios/getOrdenadoresNegocio',
      loading: false,
      lazy: true
    },
    {
      nombre: 'Impresoras Printnode',
      accion: 'negocios/getImpresorasNegocio',
      loading: false,
      lazy: true
    },
    {
      nombre: 'Descuentos',
      accion: 'descuentos/getDescuentos',
      loading: false
    },
    {
      nombre: 'Cupones',
      accion: 'cupones/getCupones',
      loading: false
    },
    /*{
      nombre : 'Clientes',
      accion : 'clientes/getClientes',
      loading : false
    },*/
    {
      nombre: 'Totems',
      accion: 'totems/getTotems',
      loading: false
    },
    {
      nombre: 'Tickets',
      accion: 'tickets/getTickets',
      loading: false
    },
    {
      nombre: 'Internos Categorias',
      accion: 'internos/getCategorias',
      loading: false,
      lazy: true
    },
    {
      nombre: 'Internos Productos',
      accion: 'internos/getProductos',
      loading: false,
      lazy: true
    },
    {
      nombre: 'Mapeo Neo',
      accion: 'negocios/getValueSecretosNegocio',
      loading: false,
      lazy: true
    },
    {
      nombre: 'Negocio',
      accion: 'negocios/getNegocioBoss',
      loading: false
    },
    {
      nombre: 'Facturacion',
      accion: 'facturacion/getDatosFacturacionNegocioGest',
      loading: false,
      lazy: true
    }
  ],
  cargasArrayDirectorio: [
    // { Se carga en el router before enter
    //   nombre: 'Directorio Gestionar',
    //   accion: 'directorios/getDirectorioGest',
    //   loading: false,
    //   esperar: true
    // },
    {
      nombre: 'Categorías',
      accion: 'directorios/getCategoriasNegocios',
      loading: false
    },
    {
      nombre: 'Restaurantes',
      accion: 'restaurantes/getRestaurantesDirectorio',
      loading: false
    },
    {
      nombre: 'Facturacion',
      accion: 'facturacion/getDatosFacturacionDirectorioGest',
      loading: false,
      lazy: true
    }
  ],
  cargasArrayBossDirectorio: [
    // {
    //   nombre: 'Directorio Gestionar',
    //   accion: 'directorios/getDirectorioGest',
    //   loading: false,
    // },
    // {
    //   nombre: 'Categorías',
    //   accion: 'directorios/getCategoriasNegocios',
    //   loading: false
    // },
    {
      nombre: 'Pedidos',
      accion: 'pedidos/getPedidosDirectorio',
      loading: false
    },
    {
      nombre: 'Restaurantes',
      accion: 'restaurantes/getRestaurantesDirectorio',
      loading: false
    },
    {
      nombre: 'Contratos',
      accion: 'contratos/getContratosDirectorio',
      loading: false
    },
    {
      nombre: 'Facturas',
      accion: 'facturacion/getFacturasDirectorio',
      loading: false
    },
  ],
  cargasArrayBossRestaurante: [
    {
      nombre: 'Negocio',
      accion: 'negocios/getNegocioBoss',
      loading: false
    },
    {
      nombre: 'Pedidos Restaurante',
      accion: 'pedidos/getPedidosRestaurante',
      loading: false
    },
    {
      nombre: 'Restaurantes',
      accion: 'restaurantes/getRestaurantesBossRestaurante',
      loading: false
    },
    {
      nombre: 'Facturacion',
      accion: 'facturacion/getFacturasRestaurante',
      loading: false,
      lazy: true
    }
  ],
  cargasArrayBossNegocio: [
    {
      nombre: 'Mensajes',
      accion: 'auth/getMensajes',
      loading: false
    },
    {
      nombre: 'Pedidos TPV',
      accion: 'pedidos/getPedidosNegocioRealizandoTpv',
      loading: false
    },
    {
      nombre: 'Restaurantes',
      accion: 'restaurantes/getModosRestaurantes',
      loading: false
    },
    /*{
      nombre: 'Pedidos Internos',
      accion: 'internos/getPedidosInternosNegocio',
      loading: false
    },*/
    {
      nombre: 'Impuestos',
      accion: 'impuestos/getImpuestos',
      loading: false
    },
    {
      nombre: 'Negocio',
      accion: 'negocios/getNegocioBoss',
      loading: false
    },
    {
      nombre: 'Pedidos',
      accion: 'pedidos/getPedidosNegocio',
      loading: false
    },
    {
      nombre: 'Clientes',
      accion: 'negocios/getClientesNegocio',
      loading: false
    },
    {
      nombre: 'Restaurantes',
      accion: 'restaurantes/getRestaurantes',
      loading: false
    },
    {
      nombre: 'Categorias',
      accion: 'categorias/getCategorias',
      loading: false
    },
    {
      nombre: 'Productos',
      accion: 'productos/getProductos',
      loading: false
    },
    {
      nombre: 'Internos Categorias',
      accion: 'internos/getCategorias',
      loading: false
    },
    {
      nombre: 'Z Cierres',
      accion: 'zcierres/getZCierresAbiertosTiempoReal',
      loading: false
    },
    {
      nombre: 'Números contables',
      accion: 'contabilidad/getNumerosContables',
      loading: false
    },

  ]
}